<template>
    <div class="forgetPayPwdWrap">
        <!-- <nav-bar></nav-bar> -->
        <div class="fc ac">
            <!-- <img class="phoneIco" src="../../../static/imgs/movie/phone.png" alt /> -->
            <!-- <span class="phoneTxt">{{phoneNo}}</span> -->
            <!-- <div v-show="memberInfo.haspaypass" class="row fr ac bb"></div> -->
            <div class="row fr ac bb">
                <span>验证码</span>
                <div class="codeBox fr ac">
                    <input v-model="code" maxlength="6" placeholder="请输入验证码" />
                    <span v-if="!disabled" @click="sendCode" class="center tc">发送验证码</span>
                    <span v-else class="center grey">{{time}}s后重发</span>
                </div>
            </div>
            <div class="row fr ac bb">
                <span>新密码</span>
                <input v-model="pwd" placeholder="6-12位字母数字组合" type="password" />
            </div>
            <div class="row fr ac">
                <span>确认新密码</span>
                <input v-model="repeatPwd" placeholder="6-12位字母数字组合" type="password" />
            </div>
            <button @click="resetPwd" class="confirmBtn tc bd_tc">确定</button>
        </div>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
import navBar from "../../components/common/navBar.vue";
export default {
    data() {
        return {
            code: "",
            pwd: "",
            repeatPwd: "",
            disabled: false,
            time: 60,
            interval: null,
            origin: this.$route.query.origin ? this.$route.query.origin : ""
        };
    },
    components: {
        navBar
    },
    created() {},
    methods: {
        sendCode() {
            this.$post({
                method: "member.paypass.verify.send",
                auth_code: this.getLocal("auth_code")
            }).then(res => {
                if (res.success) {
                    this.countDown();
                    this.disabled = true;
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                }
            });
        },
        countDown() {
            this.interval = null;
            var time = this.time;
            this.interval = setInterval(() => {
                time--;
                this.time = time;
                if (time < 1) {
                    clearInterval(this.interval);
                    this.disabled = false;
                    this.time = 120;
                }
            }, 1000);
        },
        resetPwd() {
            let pwdReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/;
            if (!this.code) {
                Toast({
                    message: "请输入验证码",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            // } else if (!this.pwd || !pwdReg.test(this.pwd)) {
            } else if (!this.pwd || this.pwd.length < 6) {
                Toast({
                    message: "请设置符合要求的新密码",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            } else if (this.pwd != this.repeatPwd) {
                Toast({
                    message: "两次输入的密码不一致",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            }
            this.$post({
                method: "member.paypass.reset",
                verify: this.code,
                paypass: this.pwd,
                auth_code: this.getLocal("auth_code")
            }).then(res => {
                if (res.success) {
                    Toast({
                        message: "密码设置成功",
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                    if (this.origin == "order") {
                        this.$router.go(-1);
                    } else {
                        this.$router.replace("/meIndex");
                    }
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                }
            });
        }
    }
};
</script>
<style scoped lang="scss">
.forgetPayPwdWrap {
    .phoneIco {
        width: 160px;
        height: 160px;
        padding: 2px;
        border: 5px solid #ffcb00;
        border-radius: 50%;
        margin-top: 40px;
    }
    .phoneTxt {
        font-size: 28px;
        margin: 20px 0 70px 0;
    }
    .row {
        height: 100px;
        width: 100%;
        padding: 0 30px;
        background-color: #fff;
        font-size: 28px;
        span {
            width: 230px;
        }
        input {
            width: 460px;
        }
        .codeBox {
            width: 460px;
            input {
                width: 60%;
                border-right: 1px solid #e4e4e4;
            }
            span {
                width: 40%;
            }
        }
    }
    .confirmBtn {
        width: 198px;
        height: 78px;
        line-height: 78px;
        border: 1px solid #E42F46;
        color: #E42F46;
        border-radius: 10px;
        background-color: #f2f2f2;
        margin-top: 50px;
        font-size: 30px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/me/forgetPayPwd.vue